import { render, staticRenderFns } from "./GeneralJobAdd.vue?vue&type=template&id=4550bfca&"
import script from "./GeneralJobAdd.vue?vue&type=script&lang=js&"
export * from "./GeneralJobAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports